/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { DatePicker } from "react-patro";

import { Line, Circle } from "rc-progress";


import PaymentHistory from "./PaymentHistory";

import "./Client.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useCustomReactQuery } from "../../utils/useCustomReactQuery";
import { config } from "../../utils/config";
import Spinner from "../../utils/Spinner";

import { format } from "date-fns";
import { ArrowLeft, CircleX, EllipsisVertical } from "lucide-react";

function ViewClient(props) {
  const licenseExpiry = new Date("2024-5-31");
  const currentDate = new Date();
  const daysRemaining = Math.ceil(
    (licenseExpiry - currentDate) / (1000 * 60 * 60 * 24)
  );
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state?.data;
  console.log(data);
  const isActive = true; // Replace with your logic to determine the status
  const [status, setStatus] = useState("active");
  const [isOpen, setIsOpen] = useState(false);

  const [records, error, isLoading] = useCustomReactQuery(
    `${config}/api/licenseDetails/getLicenseBYCompany/${data}`
  );
  if (records === undefined) {
    return <Spinner />;
  }

  const CardCompany = () => {
    const record = records[0];
console.log(record)
    const licenseExpiry = new Date(record.expireDate);
    const currentDate = new Date();
    const daysRemaining = Math.ceil(
      (licenseExpiry.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24)
    );
    const isActive = record.isCompanyActive;
    return (
      <div className="card card-company mb-2">
        <div className="card-body">
          <div className="row">
            <div className="col-md-4 col-xl-4 d-flex  flex-column  align-items-center">
              <h5 className="card-title">{record ? record.companyName : ""}</h5>
              <p className="card-text mb-1">
                {record ? record.companyAddress : ""}
              </p>
              <p className="card-text mb-1">
                {record ? record.companyPhone : ""}
              </p>
              <p className="card-text mb-1">
                {record ? record.panNo
 : ""}
              </p>
              {/* <span
                className={`badge text-success badge-success${
                  isActive ? "badge-success" : "badge-danger"
                }`}
              >
                {isActive ? "Active" : "Inactive"}
              </span> */}
              <div className="select-wrapper ">
                <label htmlFor="status">Status:</label>
                <select
                  style={{
                    outline: "none",
                    border: "none",
                    color: isActive === 1 ? "green" : "red",
                  }}
                  id="status "
                >
                  <option
                    value="active"
                    className="text-success"
                    style={{ color: isActive === 1 ? "green" : "red" }}
                  >
                    Active
                  </option>
                  <option
                    value="block"
                    className="block-option"
                    style={{ color: isActive === 1 ? "red" : "green" }}
                  >
                    Blocked
                  </option>
                </select>
              </div>
            </div>
            <div className="col-md-4 col-xl-4 d-flex flex-column align-items-center">
              <p>No .of pcs :{record ? record.totalPc : "0"}</p>
            </div>
            <div className="col-md-4 col-xl-4 d-flex flex-column align-items-center justify-content-between">
              <div className="progress-bar-status">
                <Circle
                  percent={daysRemaining}
                  strokeWidth={8}
                  trailWidth={6}
                  trailColor="#cccc"
                  strokeColor="#D33352FF"
                />
                <span className="countpercrnt">
                  <span>{daysRemaining}</span>
                </span>
              </div>
              <div>
                <p className="mb-1">License expires in {daysRemaining} days</p>
                <p className="mb-0">
                  Expiration Date: {licenseExpiry.toDateString()}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const Pcsummary = ({ pc }) => {
    const [selectedDays, setSelectedDays] = useState(7);
    const [expirationDate, setExpirationDate] = useState();
    const [days, setDays] = useState(1);
    const licenseExpiry = new Date(pc.expireDate);
    const currentDate = new Date();
    const daysRemaining = Math.ceil(
      (licenseExpiry.getTime() - currentDate.getTime()) / (1000 * 60 * 60 * 24)
    );
    const isActive = pc.isCompanyActive;
    const handleDayButtonClick = (days) => {
      setSelectedDays(days);
      const newExpirationDate = new Date();
      newExpirationDate.setDate(newExpirationDate.getDate() + days);
      setExpirationDate(newExpirationDate);
    };

    const handleDateChange = (date) => {
      setExpirationDate(date);
    };
    const handleThisDayClick = () => {
      setDays(3); // Update the number of days to 1
    };
    const handleThisYearClick = () => {
      setDays(365); // Update the number of days to 1
    };
    const handleThisWeekClick = () => {
      setDays(7); // Update the number of days to 7
    };
    const handleThisMonthClick = () => {
      setDays(30); // Update the number of days to 30
    };
   
    return (
      <div className="card  card-company mb-4">
        <div className="card-body px-2">
          <div className="d-flex justify-content-between ">
            <div>
              <h5 className="card-title mb-1">
                {pc.companySystem || "desktop"}
              </h5>
              <p className="card-text mb-0">
                <small className="text-muted">{pc.licenseMacAddress}</small>
              </p>
              <div className="select-wrapper">
                <label htmlFor="status">Status:</label>

                <select
                  style={{
                    outline: "none",
                    border: "none",
                    color: isActive === 1 ? "green" : "red",
                  }}
                  id="status "
                >
                  <option
                    value="active"
                    className="text-success"
                    style={{ color: isActive === 1 ? "green" : "red" }}
                  >
                    Active
                  </option>
                  <option
                    value="block"
                    className="block-option"
                    style={{ color: isActive === 1 ? "red" : "green" }}
                  >
                    Blocked
                  </option>
                </select>
              </div>
            </div>
            <div className="d-flex  justify-content-between gap-0">
              {daysRemaining>0 ? (
                <div className="d-flex flex-column align-items-center justify-content-between">
                  <div className="progress-bar-status">
                    <Circle
                      percent={daysRemaining}
                      strokeWidth={8}
                      trailWidth={6}
                      trailColor="#cccc"
                      strokeColor="green"
                    />
                    <span className="countpercrnt">
                      <span>{daysRemaining}</span>
                    </span>
                  </div>
                  <div>
                    <p className="px-3 mb-1"> {daysRemaining} days</p>
                    <p className="px-3 mb-0 text-danger">
                      Exp Date: {licenseExpiry.toDateString()}
                    </p>
                  </div>
                </div>
              ) : (
                <>
                  <span className="d-flex flex-row dropdown">
                  <EllipsisVertical 
                  
                      className="fs-4"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    />
                    <ul className="dropdown-menu  text-align-center">
                      <li>
                        <a
                          className="dropdown-item w-25"
                          onClick={handleThisDayClick}
                        >
                          Triduum
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item w-25"
                          onClick={handleThisWeekClick}
                        >
                          Weekly
                        </a>
                      </li>

                      <li>
                        <a
                          className="dropdown-item w-25"
                          onClick={handleThisMonthClick}
                        >
                          Month
                        </a>
                      </li>
                      <li>
                        <a
                          className="dropdown-item w-25"
                          onClick={handleThisYearClick}
                        >
                          Yearly
                        </a>
                      </li>

                      <button
                        className="border-0 bg-transparent mb-1 d-flex ms-2"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                      >
                        Custom
                      </button>
                    </ul>
                  </span>
                </>
              )}
            </div>

            <div
              className="modal fade"
              id="exampleModal"
              tabIndex="-1"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog ">
                <div className="modal-content ">
                  <div className="modal-head d-flex flex-row justify-content-between px-3 py-2 align-middle">
                    <h5 className="my-auto">Date</h5>
                    <button
                      className="border-0 bg-white text-dark fs-4 "
                      data-bs-dismiss="modal"
                    >
                      <CircleX 
                        color="red"
                        className="rounded-circle text-bg-danger"
                      />
                    </button>
                  </div>
                  <div className="modal-body">
                    <DatePicker
                      name="date"
                      value={expirationDate}
                      onChange={(e) => handleDateChange(e.target.value)}
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-info text-white fw-semibold"
                      data-bs-dismiss="modal"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const goToCompany = () => {
    navigate("/company");
  };

  return (
    <div className="container-fluid mt-2">
      <div className="shadow-black rounded">
      <ArrowLeft color="red" 
          onClick={goToCompany}
          size="35px"
     
          style={{ cursor: "pointer", border: "none" }}
        />
      </div>
      <CardCompany />
      <div className="col-md-12">
        <div className="bg-white">
          <ul
            className="nav nav-tabss nav-pills gap-5"
            id="myTab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              {" "}
              <button
                className="nav-linkii active"
                id="faq_tab_1-tab"
                data-bs-toggle="tab"
                data-bs-target="#faq_tab_1"
                type="button"
                role="tab"
                aria-controls="faq_tab_1"
                aria-selected="true"
              >
                <div className="d-flex flex-column lh-md">
                  {" "}
                  <span className="text-uppercase">Pc Summary</span>{" "}
                </div>
              </button>{" "}
            </li>
            <li className="nav-item" role="presentation">
              {" "}
              <button
                className="nav-linkii"
                id="faq_tab_2-tab"
                data-bs-toggle="tab"
                data-bs-target="#faq_tab_2"
                type="button"
                role="tab"
                aria-controls="faq_tab_2"
                aria-selected="false"
              >
                <div className="d-flex flex-column lh-md">
                  {" "}
                  <span className="text-uppercase">History</span>{" "}
                </div>
              </button>{" "}
            </li>
          </ul>
          <div className="tab-content" id="myTabContent">
            <div
              className="tab-pane fade active show"
              id="faq_tab_1"
              role="tabpanel"
              aria-labelledby="faq_tab_1-tab"
            >
              <div className="row">
                {records?.map((pc, index) => (
                  <div key={index} className="col-lg-4">
                    <Pcsummary pc={pc} />
                  </div>
                ))}
              </div>
            </div>
            <div
              className="tab-pane fade"
              id="faq_tab_2"
              role="tabpanel"
              aria-labelledby="faq_tab_2-tab"
            >
              <PaymentHistory records={records} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ViewClient;
